module.exports = __webpack_public_path__ + "img/9788970137537.5fcce4be.jpg";